export const CourseArchiveProps = {
    slicer: {
        type: Number,
        default: Infinity
    },
    paginate: {
        type: Boolean,
        default: false,
    },
}